import { Review } from '../types/review.type';

export const getIndividualTimelinePath = (review: Review): string =>
  `/timeline/${
    review.email.toUpperCase() !== 'NULL'
      ? review.email
      : review.telephone.toUpperCase() !== 'NULL'
        ? review.telephone
        : ''
  }`;
